export default {
  SET_MEDIA_MODAL_STATE(state, status) {
    state.mediaModalShown = status;
  },
  SET_DATE_PICKER_SHORTCUT(state, value) {
    state.datePickerShortcut = value;
  },
  SET_DATE_PICKER_RANGE(state, range) {
    if (!range || !range[0] || !range[0]._isAMomentObject) {
      return;
    }
    state.datePickerStartDate = range[0].unix();
    state.datePickerEndDate = range[1].unix();
  },
  SET_DATE_PICKER_RESOLUTION(state, resolution) {
    state.datePickerResolution = resolution;
  },
  CLEAR_DATE_PICKER_RESOLUTION(state) {
    state.datePickerResolution = null;
  },
  SET_NUMBERS_FILTER(state, numbers) {
    state.datePickerNumbersFilter = numbers;
  },
};
